import * as Sentry from "@sentry/react";

import ErrorFallback from "@components/common/ErrorFallback";
import TestDashboardNav from "../dashboard/TestDashboardNav";
import { useLocation } from "react-router-dom";

export default function BasePage(props) {
  const { pathname } = useLocation();

  return (
    <>
      <TestDashboardNav />
      <Sentry.ErrorBoundary
        key={pathname}
        fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}
      >
        {props.component}
      </Sentry.ErrorBoundary>
    </>
  );
}
